// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version
// MODFIED DATE : 05-09-2025

import VerificationDetailsActionTypes from './verification-details.types';

/** ***************** ADD BUSINESS VERIFICATION START *********************** */
export const addBusinessVerificationStart = (verifuData: any) => ({
	type: VerificationDetailsActionTypes.ADD_BUSINESS_VERIFICATION_START,
	payload: verifuData,
});

export const addBusinessVerificationSuccess = (successValue: any) => ({
	type: VerificationDetailsActionTypes.ADD_BUSINESS_VERIFICATION_SUCCESS,
	payload: successValue,
});

export const addBusinessVerificationFailure = (failureData: any) => ({
	type: VerificationDetailsActionTypes.ADD_BUSINESS_VERIFICATION_FAILURE,
	payload: failureData,
});

export const addBusinessVerificationResponseResetStart = () => ({
	type: VerificationDetailsActionTypes.ADD_BUSINESS_VERIFICATION_RESPONSE_RESET,
});

export const addBusinessVerificationResponseChanged = () => ({
	type: VerificationDetailsActionTypes.ADD_BUSINESS_VERIFICATION_RESPONSE_CHANGED,
});

/** ***************** ADD BUSINESS VERIFICATION END *********************** */

/** ***************** UPDATE BUSINESS VERIFICATION START *********************** */
export const updateBusinessVerificationStart = (updateData: any) => ({
	type: VerificationDetailsActionTypes.UPDATE_BUSINESS_VERIFICATION_START,
	payload: updateData,
});

export const updateBusinessVerificationSuccess = (successData: any) => ({
	type: VerificationDetailsActionTypes.UPDATE_BUSINESS_VERIFICATION_SUCCESS,
	payload: successData,
});

export const updateBusinessVerificationFailure = (failureData: any) => ({
	type: VerificationDetailsActionTypes.UPDATE_BUSINESS_VERIFICATION_FAILURE,
	payload: failureData,
});

export const updateBusinessVerificationResponseResetStart = () => ({
	type: VerificationDetailsActionTypes.UPDATE_BUSINESS_VERIFICATION_RESPONSE_RESET,
});

export const updateBusinessVerificationResponseChanged = () => ({
	type: VerificationDetailsActionTypes.UPDATE_BUSINESS_VERIFICATION_RESPONSE_CHANGED,
});

/** ***************** UPDATE BUSINESS VERIFICATION END *********************** */

/** ***************** FETCH BUSINESS VERIFICATION START *********************** */
export const fetchBusinessVerificationStart = (fetchData: any) => ({
	type: VerificationDetailsActionTypes.FETCH_BUSINESS_VERIFICATION_START,
	payload: fetchData,
});

export const fetchBusinessVerificationSuccess = (successValue: any) => ({
	type: VerificationDetailsActionTypes.FETCH_BUSINESS_VERIFICATION_SUCCESS,
	payload: successValue,
});

export const fetchBusinessVerificationFailure = (failureData: any) => ({
	type: VerificationDetailsActionTypes.FETCH_BUSINESS_VERIFICATION_FAILURE,
	payload: failureData,
});

export const fetchBusinessVerificationResponseResetStart = () => ({
	type: VerificationDetailsActionTypes.FETCH_BUSINESS_VERIFICATION_RESPONSE_RESET,
});

export const fetchBusinessVerificationResponseChanged = () => ({
	type: VerificationDetailsActionTypes.FETCH_BUSINESS_VERIFICATION_RESPONSE_CHANGED,
});
/** ***************** FETCH BUSINESS VERIFICATION END *********************** */

/** ***************** DELETE BUSINESS VERIFICATION START *********************** */
export const deleteBusinessVerificationStart = (fetchData: any) => ({
	type: VerificationDetailsActionTypes.DELETE_BUSINESS_VERIFICATION_START,
	payload: fetchData,
});

export const deleteBusinessVerificationSuccess = (successValue: any) => ({
	type: VerificationDetailsActionTypes.DELETE_BUSINESS_VERIFICATION_SUCCESS,
	payload: successValue,
});

export const deleteBusinessVerificationFailure = (failureData: any) => ({
	type: VerificationDetailsActionTypes.DELETE_BUSINESS_VERIFICATION_FAILURE,
	payload: failureData,
});

export const deleteBusinessVerificationResponseResetStart = () => ({
	type: VerificationDetailsActionTypes.DELETE_BUSINESS_VERIFICATION_RESPONSE_RESET,
});

export const deleteBusinessVerificationResponseChanged = () => ({
	type: VerificationDetailsActionTypes.DELETE_BUSINESS_VERIFICATION_RESPONSE_CHANGED,
});
/** ***************** DELETE BUSINESS VERIFICATION END *********************** */
